import { render } from "./PermissionToEditModal.vue?vue&type=template&id=0ca67fae"
import script from "./PermissionToEditModal.vue?vue&type=script&lang=js"
export * from "./PermissionToEditModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__